import { render } from "./Detail.vue?vue&type=template&id=4107ea36&scoped=true&ts=true"
import script from "./Detail.vue?vue&type=script&lang=ts"
export * from "./Detail.vue?vue&type=script&lang=ts"

import "./Detail.vue?vue&type=style&index=0&id=4107ea36&lang=less&scoped=true"

import exportComponent from "D:\\work\\project\\mobile-mpe\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4107ea36"]])

export default __exports__